// Import auth utilities
import { checkResponseStatus } from '../utils/authUtils';

// Club service for club-related API calls

const BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

function getAuthToken() {
  return localStorage.getItem('access_token') || sessionStorage.getItem('access_token');
}

export async function createClubOffer({ description, instruction, from_date, to_date, image }) {
  const formData = new FormData();
  formData.append('description', description);
  formData.append('instruction', instruction);
  formData.append('from_date', from_date);
  formData.append('to_date', to_date);
  if (image) {
    formData.append('image', image);
  }

  const accessToken = getAuthToken();
  const headers = {};
  if (accessToken) {
    headers['Authorization'] = `Bearer ${accessToken}`;
    headers['Cookie'] = `jwt=${accessToken}`;
  }

  const response = await fetch(`${BASE_URL}api/v1/dashboard/club/create`, {
    method: 'POST',
    body: formData,
    headers,
  });

  // Check for 401 status
  checkResponseStatus(response);

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.message || 'Failed to create club offer');
  }

  return response.json();
}

export async function fetchClubOffers(params = {}) {
  const accessToken = getAuthToken();
  const headers = {};
  if (accessToken) {
    headers['Authorization'] = `Bearer ${accessToken}`;
    headers['Cookie'] = `jwt=${accessToken}`;
  }

  // Build query parameters with pagination
  const queryParams = new URLSearchParams();
  if (params.page) {
    queryParams.append('page', params.page);
  }
  if (params.limit) {
    queryParams.append('limit', params.limit);
  }

  const queryString = queryParams.toString();
  const url = `${BASE_URL}api/v1/dashboard/club${queryString ? `?${queryString}` : ''}`;

  const response = await fetch(url, {
    method: 'GET',
    headers,
  });

  // Check for 401 status
  checkResponseStatus(response);

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.message || 'Failed to fetch club offers');
  }

  const data = await response.json();
  // Return the data with pagination info
  return {
    data: data?.data?.data || [],
    pagination: data?.data?.pagination,
    total: data?.data?.total
  };
}

export async function fetchClubOfferById(id) {
  const accessToken = getAuthToken();
  const headers = {};
  if (accessToken) {
    headers['Authorization'] = `Bearer ${accessToken}`;
    headers['Cookie'] = `jwt=${accessToken}`;
  }

  const response = await fetch(`${BASE_URL}api/v1/dashboard/club/${id}`, {
    method: 'GET',
    headers,
  });

  // Check for 401 status
  checkResponseStatus(response);

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.message || 'Failed to fetch club offer details');
  }

  const data = await response.json();
  return data?.data;
}

export async function updateClubOffer(id, { description, instruction, from_date, to_date, is_active, image }) {
  const formData = new FormData();
  formData.append('description', description);
  formData.append('instruction', instruction);
  formData.append('from_date', from_date);
  formData.append('to_date', to_date);
  formData.append('is_active', is_active);
  if (image) {
    formData.append('image', image);
  }

  const accessToken = getAuthToken();
  const headers = {};
  if (accessToken) {
    headers['Authorization'] = `Bearer ${accessToken}`;
    headers['Cookie'] = `jwt=${accessToken}`;
  }

  const response = await fetch(`${BASE_URL}api/v1/dashboard/club/update/${id}`, {
    method: 'PATCH',
    body: formData,
    headers,
  });

  // Check for 401 status
  checkResponseStatus(response);

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.message || 'Failed to update club offer');
  }

  return response.json();
}

export async function deleteClubOffer(id) {
  const accessToken = getAuthToken();
  const headers = {};
  if (accessToken) {
    headers['Authorization'] = `Bearer ${accessToken}`;
  }

  const response = await fetch(`${BASE_URL}api/v1/dashboard/club/delete/${id}`, {
    method: 'DELETE',
    headers,
  });

  // Check for 401 status
  checkResponseStatus(response);

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.message || 'Failed to delete club offer');
  }

  return response.json();
}

export async function fetchOfferCustomers(offerId) {
  const accessToken = getAuthToken();
  const headers = {};
  if (accessToken) {
    headers['Authorization'] = `Bearer ${accessToken}`;
  }
  const response = await fetch(`${BASE_URL}api/v1/dashboard/club/get-club-offer/${offerId}`, {
    method: 'GET',
    headers,
  });

  // Check for 401 status
  checkResponseStatus(response);

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.message || 'Failed to fetch offer customers');
  }
  const data = await response.json();
  return data.data?.data || [];
}